import React from 'react';
import SingleBar from './SingleBar';
import MutipleBar from './MutipleBar';
import { ICapsuleBarProps } from './type.d';
import './index.scss';

export default function CapsuleBar({
  data,
  mode = 'single',
  height = 80,
  coefficient,
  directionType = 'normal',
  maxValue,
  valueFormatter,
}: ICapsuleBarProps) {

  return (
    <div className='capsule-bar'>
      {
        mode === 'single'
          ? <SingleBar
            data={data}
            height={height}
            coefficient={coefficient}
            directionType={directionType}
            maxValue={maxValue}
            valueFormatter={valueFormatter}
          />
          : <MutipleBar
            data={data}
            height={height}
            coefficient={coefficient}
            directionType={directionType}
            maxValue={maxValue}
            valueFormatter={valueFormatter}
          /> 
      }
    </div>
  );
}